/** Neutral light-gray background shared by informational chips (labor certificate, "se hace en X"). */
export const NEUTRAL_CHIP_BG = "#EAEFF4";
